import type { ComponentProps } from 'react';
import React from 'react';
import { HorizontalScrollRail } from '../../HorizontalScrollRail';
import { useResponsive } from '../../../hooks';

// ────────────────────────────────────────────────────────────────────

export const LoyaltyChallengeCardsRailBase = (
  props: LoyaltyChallengeCardsRailBaseProps,
) => {
  const { headerText, footerText, children, ...restProps } = props;

  const { minWidth } = useResponsive();

  return (
    <HorizontalScrollRail
      heading={headerText}
      footerText={footerText}
      showNavControls={minWidth.tablet}
      gap={0}
      itemVisiblePercentThreshold={99}
      countPosition={minWidth.tablet ? 'left' : 'right'}
      {...restProps}
    >
      {children as readonly React.ReactNode[]}
    </HorizontalScrollRail>
  );
};

// ─── TYPES ─────────────────────────────────────────────────────────────────

export type LoyaltyChallengeCardsRailBaseProps = {
  readonly headerText: string;
  readonly footerText?: string;
  readonly gap?: number;
  readonly count?: number;
} & Partial<ComponentProps<typeof HorizontalScrollRail>>;
